import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

import type { Editor } from '@tiptap/core'

export type PreservedSelectionRange = { from: number; to: number } | null

export const preservedSelectionPluginKey =
  new PluginKey<PreservedSelectionRange>('announcementPreservedSelection')

export const setPreservedSelection = (
  editor: Editor,
  range: PreservedSelectionRange
) => {
  if (!editor.view) {
    return
  }

  editor.view.dispatch(
    editor.state.tr.setMeta(preservedSelectionPluginKey, range)
  )
}

export const PreservedSelection = Extension.create({
  name: 'preservedSelection',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: preservedSelectionPluginKey,
        state: {
          init: (): PreservedSelectionRange => null,
          apply(tr, range): PreservedSelectionRange {
            const meta = tr.getMeta(preservedSelectionPluginKey) as
              | PreservedSelectionRange
              | undefined

            if (meta !== undefined) {
              return meta
            }

            if (!range) {
              return null
            }

            return {
              from: tr.mapping.map(range.from),
              to: tr.mapping.map(range.to),
            }
          },
        },
        props: {
          decorations(state) {
            const range = preservedSelectionPluginKey.getState(state)

            if (!range || range.from === range.to) {
              return DecorationSet.empty
            }

            return DecorationSet.create(state.doc, [
              Decoration.inline(range.from, range.to, {
                class: 'announcement-editor-preserved-selection',
              }),
            ])
          },
        },
      }),
    ]
  },
})
